const photosNA = "No photos available";
const photos = [
  {
    label: "2003",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/VZMQVDLb9rYezXbt5",
      "Miscellaneous Photos": "https://photos.app.goo.gl/3KbdhEF3aQgcqfaw8"
    },
  },
  {
    label: "2005",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/fiTnrUCgpAK162Hj9",
      "Miscellaneous Photos": "https://photos.app.goo.gl/AaiwiGAL7uoW1b5t9"
    },
  },
  {
    label: "2007",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/sHRpfe6cF6d5Ra1r5",
      "Miscellaneous Photos": "https://photos.app.goo.gl/SSCoT4x5k6o1CC9k8"
    },
  },
  {
    label: "2009",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/cFNvzpBfeCtkfLP69",
      "Miscellaneous Photos": ""
    },
  },
  {
    label: "2011",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/4CmdC8i3UmuXNyLE7",
      "Miscellaneous Photos": "https://photos.app.goo.gl/cFGCRZaym9Dtf9Zq7"
    },
  },
  {
    label: "2013",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/39UNEbn6wLqtXEBf6",
      "Miscellaneous Photos": "https://photos.app.goo.gl/tdBpqhMrY8ELt8jNA"
    },
  },
  {
    label: "2015",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/SoC6poabXYGGrK8k6",
      "Miscellaneous Photos": "https://photos.app.goo.gl/HEMaZMDxbLEkVrhW6"
    },
  },
  {
    label: "2017",
    groups: {
      "Group Photos": photosNA,
      "Miscellaneous Photos": photosNA
    }, 
  },
  {
    label: "2019",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/1h1eqSYuTWfY3TgB6",
      "Miscellaneous Photos": "https://photos.app.goo.gl/sdPGUUjcHCHpuPdJ7",
      "Games Photos": "https://photos.app.goo.gl/xwTHWHGRucfoB3LAA"
    },
  },
  {
    label: "2021",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/RbGaCqAzboFPARYM8",
      "Miscellaneous Photos": "https://photos.app.goo.gl/hcNazPgkWWJtJeRc7"
    },
  },
  {
    label: "2023",
    groups: {
      "Group Photos": "https://photos.app.goo.gl/NBqb2f3ey3MMiokK7",
      "Miscellaneous Photos": "https://photos.app.goo.gl/Wm3EUTcWWRydhPZK8"
    },
  },
];

export { photos, photosNA };